import config from '../config'

const BASE = config.isProd ? 'https://www.spotme.mx' : 'https://dev.spotme.mx'
const PATH = '/_next/image'

type IOptions = {
  w?: number
  h?: number
  q?: number
}

/**
 * Generate Next Optimized Image URL
 * @param imgUrl full url or relative path (public)
 * @param param1
 * @returns
 */
export function imgUrl(
  imgUrl: string,
  { w = 1200, h = 628, q = 75 }: IOptions
): string {
  const url = new URL(PATH, BASE)
  url.searchParams.set('url', imgUrl)
  url.searchParams.set('w', w.toString())
  if (h) url.searchParams.set('h', h.toString())
  url.searchParams.set('q', q.toString())

  return url.toString()
}

const PRIVATE_IMAGE_HOST =
  /^https:\/\/spotme-private-images(?:-dev)?\.s3\.us-west-1\.amazonaws\.com\//

/**
 * True for a file in the private S3 buckets (KYC IDs, constancias, chat
 * attachments, storage-item / check-in photos, dispute evidence), which is
 * only ever reachable through a short-lived signed URL.
 *
 * Such a URL must NEVER go through the Next image optimizer: its output is
 * cached on the public CDN for `minimumCacheTTL` (one year), keyed by the
 * signed URL but served without re-checking the signature — a one-hour
 * credential becomes a year-long public copy of someone's ID (security audit
 * 2026-09-27, M1). The private hosts are therefore NOT in next.config.js
 * `remotePatterns`, so every `next/image` that can render one must pass
 * `unoptimized={isPrivateImageUrl(src)}` or the image renders broken.
 */
export const isPrivateImageUrl = (src: unknown): boolean =>
  typeof src === 'string' && PRIVATE_IMAGE_HOST.test(src)

export const base64ToFile = (dataUrl: string, filename: string) => {
  const arr = dataUrl.split(',')
  if (arr.length < 2) {
    return null
  }
  const mimeArr = arr[0].match(/:(.*?);/)
  if (!mimeArr || mimeArr.length < 2) {
    return null
  }
  const mime = mimeArr[1]
  const buff = Buffer.from(arr[1], 'base64')
  return new File([buff], filename, { type: mime })
}

export const fileToFileList = (file: File) => {
  const list = new DataTransfer()
  list.items.add(file)
  return list.files
}
